import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-107">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-108">
          <motion.div className="absolute inset-0 bg-black/50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} aria-hidden="true" data-id="element-109" />

          <motion.div className="relative w-full max-w-2xl max-h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-110">
            <div className="sticky top-0 flex items-center justify-between p-5 border-b bg-white" style={{
          borderColor: '#C5DDD1'
        }} data-id="element-111">
              <h2 id="modal-title" className="text-xl md:text-2xl font-semibold" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#1A1A1A'
          }} data-id="element-112">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full transition-colors" style={{
            backgroundColor: '#F0F7F4'
          }} aria-label="Cerrar" data-id="element-113">
                <XIcon className="w-5 h-5" style={{
              color: '#1A1A1A'
            }} data-id="element-114" />
              </button>
            </div>

            <div className="p-5 md:p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-115">
              <div className="prose prose-sm max-w-none" style={{
            color: '#4A4A4A'
          }} data-id="element-116">
                {children}
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}